import { TourManager } from "./TourManager";
import verascendTour from "./content/verascendTour.json";
export const manager = new TourManager(verascendTour);
